<template>
  <!--开票申请页面-->
  <div class="container">
    <div class="header">
      <i class="icon-fanhui iconfont icon back" @click="back" style="position: absolute;left:0.1rem"></i>
      <div>开票申请</div>
    </div>
    <mt-navbar v-model="selected" >
      <mt-tab-item id="1">开票信息</mt-tab-item>
      <mt-tab-item id="2">开票金额</mt-tab-item>
      <mt-tab-item id="3">开票留言</mt-tab-item>
    </mt-navbar>
    <mt-tab-container v-model="selected">
      <mt-tab-container-item id="1">
       <!--开票申请页面-->
        <ul class="openticketmsg">
          <li>
           <span ><i class="require_icon">*</i>项目名称</span>
            <span class="child01">
                <!--<span  v-if="Step.step==1" @click="getProjectList()"  style="display: inline-block;width:6rem;height:20px;">{{project_name}} <span v-if="!project_name">点击选择项目名字</span></span>-->
                <span v-if="Step.step==1" @click="getProjectList()"  style="display: inline-block;width:6rem;height:20px;">{{project_name}} <span v-if="!project_name">点击选择项目名字</span></span>

              <!--<span  v-if="Step.step==1 &&!project_name"  style="display: inline-block;position: absolute;top:0;left:3rem;color:#ccc;">点击选择项目名称</span>-->
                <span v-else>{{project_list[Storemsg.order_id]}}</span>
            </span>
          </li>
          <li>
            <span><i class="require_icon">*</i>开票名称</span>
            <span style="margin-left: 1.1rem">

              <input v-if="state=='5'||state=='4'||state=='1'" type="text" placeholder="不填默认是项目名称"  v-model="Storemsg.project_name"/>
              <span v-else>{{Storemsg.project_name}}</span>
            </span>
          </li>
          <li>
            <span><i class="require_icon">*</i>甲方名称</span>
            <span style="margin-left: 1.1rem">
              <span>{{company_name}}</span>
            </span>
          </li>
          <li>
            <span style="margin-left:0.2rem">智能填充</span>
            <button class="fillbtn" @click="FullBtnAction" v-if="state=='5'||state=='4'||state=='1'">点我可以智能填充噢</button>
            <button class="fillbtn" @click="FullBtnAction" v-else disabled>点我可以智能填充噢</button>
          </li>
          <li>
            <span><i class="require_icon">*</i>事业部选择</span>
            <span style="margin-left: 1.2rem" v-if="state=='5'||state=='4'||state=='1'">
              <select style="background: #fff"  v-model="Storemsg.account" placeholder="请选择事业几部的销售" >
                <option v-for="(item,index) in account_list" :value="index" :key="index" >{{item}}</option>
              </select>
            </span>
            <span v-else>{{Storemsg.account}}</span>
          </li>

          <li>
            <span><i class="require_icon">*</i>纳税人识别号</span>
            <span class="child02">
              <input v-if="state=='5'||state=='4'||state=='1'" type="text" placeholder="请输入" v-model="Storemsg.taxpayer_num"/>
              <span v-else>{{Storemsg.taxpayer_num}}</span>
            </span>
          </li>
          <li>
            <span><i class="require_icon">*</i>开票开户银行</span>
            <span class="child02">
              <input v-if="state=='5'||state=='4'||state=='1'" type="text" placeholder="请输入" v-model="Storemsg.inv_bank_name"/>
               <span v-else>{{Storemsg.inv_bank_name}}</span>
            </span>
          </li>
          <li>
            <span><i class="require_icon">*</i>开票银行账号</span>
            <span class="child02">
               <!--<span v-if="state=='2'||state=='3'">{{Storemsg.inv_bank_account}}</span>-->
              <input v-if="state=='5'||state=='4'||state=='1' " type="text" placeholder="请输入" v-model="Storemsg.inv_bank_account"/>
              <span v-else>{{Storemsg.inv_bank_account}}</span>
            </span>
          </li>
          <li>
            <span><i class="require_icon">*</i>开票电话</span>
            <span class="child01">
               <input v-if="state=='5'||state=='4'||state=='1'" type="text" placeholder="请输入" v-model="Storemsg.inv_phone"/>
              <span v-else>{{Storemsg.inv_phone}}</span>
            </span>
          </li>
          <li style="min-height:1.4rem;">
            <span style="position:relative;top:-0.6rem;"><i class="require_icon">*</i>开票地址</span>
            <span class="child01">
              <textarea v-if="state=='5'||state=='4'||state=='1' " type="textarea" placeholder="请输入" v-model="Storemsg.inv_address"
              style="min-height:1.1rem;width:6.5rem;margin-top:0.2rem;"/>
              <span v-else>{{Storemsg.inv_address}}</span>
            </span>
          </li>
          <div style="border-bottom:1px solid #ccc;height:2rem;">
            <span style="margin-left: 0.3rem;display:inline-block;margin-top:0.2rem;"><i class="require_icon">*</i>发票栏备注内容</span>
            <textarea v-if="state=='5'||state=='4'||state=='1' "  placeholder="请输入发票是否需要备注,若需要输入备注内容" v-model='Storemsg.rev_remark'
                      style="padding-left:0.3rem;height:1.3rem;width:100%"/>
            <span v-else style="margin-left: 0.2rem">{{Storemsg.rev_remark}}</span>
          </div>
          <li class="child">
            <div class="radiobox">
              <span><i class="require_icon">*</i>对方企业性质</span>
              <span style="margin-left: 0.5rem;margin-right:1.5rem;">
                <input type="radio"  v-if="state=='5'||state=='4'||state=='1' "  name="company_char" value="2" :checked="Storemsg.company_char==2" @click="companycharbtn(2)">
                <input type="radio" v-else name="company_char" value="2" :checked="Storemsg.company_char==2" @click="companycharbtn(2)" disabled>
                 <label>一般纳税人</label>
              </span>
              <span  >
                <input type="radio" v-if="state=='5'||state=='4'||state=='1' " name="company_char" :value="1"  :checked="Storemsg.company_char==1" @click="companycharbtn(1)" >

                <input type="radio" v-else name="company_char" :value="1"  :checked="Storemsg.company_char==1" @click="companycharbtn(1)" disabled>
                 <label>小规模纳税人</label>
              </span>

            </div>
          </li>
          <li class="child">
            <div class="radiobox">
              <span><i class="require_icon">*</i>开票类型</span>
              <span style="margin-left:1.1rem;margin-right:0.9rem;">
                <input   v-if="state=='5'||state=='4'||state=='1' " type="radio" name="inv_type" :value="1"  :checked="Storemsg.inv_type==1" @click="invtypebtn(1)">
                <input v-else type="radio" name="inv_type" :value="1"  :checked="Storemsg.inv_type==1" @click="invtypebtn(1)" disabled>
                <label>增值税专用发票</label>
              </span>
              <span >
                <input type="radio" v-if="state=='5'||state=='4'||state=='1' " name="inv_type" value="2" :checked="Storemsg.inv_type==2"  @click="invtypebtn(2)">
                <input type="radio" v-else name="inv_type" value="2" :checked="Storemsg.inv_type==2"  @click="invtypebtn(2)" disabled>
                <label>普通发票</label>
               </span>
            </div>
          </li>
          <li class="child">
            <div class="radiobox">
              <span><i class="require_icon">*</i>发票是否邮寄</span>
              <span style="margin-left:0.5rem;margin-right:2.76rem;">
                  <input type="radio" v-if="state=='5'||state=='4'||state=='1' "  name="need_mail" :value="1"  @click="needmailbtn(1)" :checked="Storemsg.need_mail==1" v-model="Storemsg.need_mail">
                  <input type="radio" v-else name="need_mail" :value="1"  @click="needmailbtn(1)" :checked="Storemsg.need_mail==1" v-model="Storemsg.need_mail" disabled>
                 <label>是</label>
              </span>
              <span>
                  <input v-if="state=='5'||state=='4'||state=='1' " type="radio" name="need_mail" value="2" @click="needmailbtn(2)" :checked="Storemsg.need_mail==2" v-model="Storemsg.need_mail">
                  <input  v-else type="radio" name="need_mail" value="2" @click="needmailbtn(2)" :checked="Storemsg.need_mail==2" v-model="Storemsg.need_mail" disabled>
                  <label>否</label>
               </span>
            </div>
          </li>

          <!--如果邮寄才显示收件人信息-->
          <li v-if="Storemsg.need_mail==1">
            <span><i class="require_icon">*</i>收件人</span>
            <span  style="margin-left:1.5rem">
              <input v-if="state=='5'||state=='4'||state=='1' " type="text" placeholder="请输入" v-model="Storemsg.mail_user" />
              <span v-else >{{Storemsg.mail_user}}</span>
            </span>
          </li>
          <li v-if="Storemsg.need_mail==1">
            <span><i class="require_icon">*</i>收件人电话</span>
            <span style="margin-left: 0.9rem">
              <input v-if="state=='5'||state=='4'||state=='1' "  type="text" placeholder="请输入" v-model="Storemsg.mail_phone"/>
              <span v-else >{{Storemsg.mail_phone}}</span>
            </span>
          </li>
          <li  v-if="Storemsg.need_mail==1" style="height:1.5rem;">
            <span style="position:relative;top:-0.5rem"><i class="require_icon">*</i>邮件地址</span>
            <span class="child01">
              <textarea v-if="state=='5'||state=='4'||state=='1' " type="text" placeholder="请输入" v-model="Storemsg.mail_address"
              style="min-height:1.2rem;margin-top:0.2rem;width:6.5rem;"/>
              <span v-else >{{Storemsg.mail_address}}</span>
            </span>
          </li>

          <li class="child">
            <div class="radiobox">
              <span><i class="require_icon">*</i>审核类型</span>
              <span style="margin-left: 1.1rem;margin-right: 2.5rem;">
                  <input type="radio"  v-if="state=='5'||state=='4'||state=='1' "  name="type" :value="1"  checked @click="normaltypebtn(1)" v-model="Storemsg.type">
                  <input type="radio" v-else name="type" :value="1"  checked @click="normaltypebtn(1)" v-model="Storemsg.type" disabled>
                 <label>正常</label>
              </span>
              <span>
                  <input type="radio" v-if="state=='5'||state=='4'||state=='1' " name="type" :value="2"  @click="normaltypebtn(2)" v-model="Storemsg.type" >
                  <input type="radio" v-else name="type" :value="2"  @click="normaltypebtn(2)" v-model="Storemsg.type" disabled>
                  <label>特殊</label>
               </span>
            </div>
          </li>
            <div class="leader">
              <p class="leader_title">审批人</p>
              <div>
                <!--正常-->
                <div class="userimg" v-if="Storemsg.type==1">
                   <img src="../../assets/img/user-avatar.png" alt="" class="img02">
                   <span class="avatar-name" >陈</span>
                    <div style="margin:0.2rem">陈明玲</div>
                </div>
                <!--特殊-->
                <div v-if="Storemsg.type==2">
                  <ul class="all_leader">
                    <li style="margin-left:0.3rem">
                      <img src="../../assets/img/user-avatar.png" alt="" class="img02">
                      <span class="dasheline"></span>
                      <span class="avatar-name"  >{{leader.name?(leader.name).slice(0,1):''}}</span>
                      <div style="margin:0.2rem">{{leader.name}}</div>
                    </li>
                    <li>
                      <img src="../../assets/img/user-avatar.png" alt="" class="img02">
                      <span class="dasheline"></span>
                      <span class="avatar-name"  >孙</span>
                      <div style="margin:0.2rem">孙文博</div>
                    </li>
                    <li>
                      <img src="../../assets/img/user-avatar.png" alt="" class="img02">
                      <span class="avatar-name" >陈</span>
                      <div style="margin:0.2rem">陈明玲</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>



        </ul>
        <!--<div class="store-wrap">-->
          <!--<div class="storemsg" @click="StoreConirm">保存</div>-->
        <!--</div>-->


      </mt-tab-container-item>
      <!--开票金额页面-->
      <mt-tab-container-item id="2">
        <div class="openticketmoney-wrap">
          <!--添加按钮-->
          <div class="openticketmoney" >
            <div style="overflow: hidden;">
              <div class="addmoney" @click="addmoneybtn" v-if="state=='5'||state=='4'||state=='1' " >
                <span style="margin:0 0.1rem;">+</span>添加金额
              </div>
              <div v-else></div>

            </div>
            <!--添加信息框-->
            <div class="ticketbox-wrap">
              <!--添加信息框-->
              <ul class="ticketbox-content" v-for="(item,index) in Storemsg.money" :key="index">
                <li>
                  <span><i class="require_icon">*</i>开票金额</span>
                  <span>
                    <input v-if="state=='5'||state=='4'||state=='1' " type="text" placeholder="请输入开票金额" v-model="Storemsg.money[index]" ref="allmoney"/>
                   <span v-else>{{Storemsg.money[index]}}</span>
                </span>
                </li>
                <li style="border:none">
                  <span style="width:1.2rem;"><i class="require_icon">*</i>税率</span>
                  <span style="margin-left:0.3rem;">
                     <select  v-if="state=='5'||state=='4'||state=='1' "  style="width:100%;background: #fff;"  v-model="Storemsg.tax_type[index]" >
                       <option :value="index" v-for="(item,index) in tax_list" :key="index">{{item}}</option>
                     </select>
                    <span v-else >{{Storemsg.tax_type[index]}}</span>

                </span>
                </li>

                <!--预计回款时间-->
                <li style="border-top:1px solid #F0F0F0;" v-if="state=='5'||state=='4'||state=='1' ">
                  <span><i class="require_icon">*</i>预计回款时间</span>
                  <span  style="display:inline-block;width:5.3rem;height:1.2rem;"  @click="openclick(index)" >{{Storemsg.scheduled_at[index]}}</span>
                  <!--<input  style="display:inline-block;width:3.2rem;height:1.2rem;"  @click="openclick(index)" v-model="Storemsg.scheduled_at[index]|formatDate"></input>-->


                  <mt-datetime-picker class="picker_show"
                                      ref="picker"
                                      type="date"
                                      :startDate = "startDate"
                                      :endDate = "endDate"
                                      @confirm="handleConfirm"
                                      @cancel="handleCancel"

                  ></mt-datetime-picker>

                </li>
                <li style="border-top:1px solid #F0F0F0;" v-else>
                  <span><i class="require_icon">*</i>预计回款时间</span>
                  <span  style="display:inline-block;width:5.2rem;height:1.2rem;" >{{Storemsg.scheduled_at[index]| formatDate}}</span>
                  <!--<input  style="display:inline-block;width:3.2rem;height:1.2rem;"  @click="openclick(index)" v-model="Storemsg.scheduled_at[index]|formatDate"></input>-->



                </li>
                <div class="icon_del" @click="delmoneybtn(index)"  v-if="state=='5'||state=='4'||state=='1' " ></div>
                <div v-else></div>
              </ul>

            </div>
          </div>
          <!--保存-->
          <!--<div class="store-wrap2">-->
            <!--<div class="storemsg" @click="openticketmoney">保存</div>-->
          <!--</div>-->
        </div>
        <mt-popup
          v-model="popupVisible"
          position="bottom"
          popup-transition="popup-fade"
          :modal="true">
          <div style="width:360px;height: 6rem;">
            <div class="issurebtn">
              <span class="cancelbtn" @click="cancelbtn">取消</span>
              <span class="surebtn" @click="cancelbtn">确定</span>
            </div>
            <div class="choosetax">
              <ul class="taxs">
                <li>
                  <span>6%</span>
                  <span>（其他电子设备*辅助设备）</span>
                </li>
                <li class="list-item">
                  <span>16%</span>
                  <span>（*软件*思为软件三维远程展示系统V1.0）</span>
                </li>
              </ul>
            </div>
          </div>

        </mt-popup>
      </mt-tab-container-item>

      <!--开票留言页面-->
      <mt-tab-container-item id="3">
        <!--<div>开票留言页面</div>-->
        <div class="saylist">
          <ul class="openticketmsg">
            <!--合同情况-->
            <li class="child">
              <div class="radiobox">
                <span><i class="require_icon">*</i>合同情况:</span>

                <span style="margin-left:1rem;margin-right:2.25rem;">
                  <input type="radio" v-if="state=='5'||state=='4'||state=='1' " name="have_h" :value="1"  @click="havehbtn(1)" :checked="Storemsg1.have_h==1" v-model="Storemsg1.have_h">
                  <input type="radio" v-else name="have_h" :value="1"  @click="havehbtn(1)" :checked="Storemsg1.have_h==1" v-model="Storemsg1.have_h" disabled>
                 <label>有</label>
              </span>
                <span>
                  <input v-if="state=='5'||state=='4'||state=='1' " type="radio" name="have_h" value="2" @click="havehbtn(2)" :checked="Storemsg1.have_h==2" v-model="Storemsg1.have_h">
                  <input  v-else type="radio" name="have_h" value="2" @click="havehbtn(2)" :checked="Storemsg1.have_h==2" v-model="Storemsg1.have_h" disabled>
                  <label>无</label>
               </span>
              </div>
            </li>
            <div style="border-bottom:1px solid #ccc;width:100%;height:1.8rem;" v-if="Storemsg1.have_h==2" >
              <span v-if="state=='5'||state=='4'||state=='1' " style="position:relative;top:-1rem;left:0.25rem;"><i class="require_icon">*</i>合同备注</span>
              <span  v-else style="position:relative;top:0.3rem;left:0.25rem;"><i class="require_icon">*</i>合同备注</span>
              <textarea v-if="state=='5'||state=='4' ||state=='1'"   placeholder="请说明合同是否双方盖章，如果不是，请备注什么时候可以上传Boss系统" v-model='Storemsg1.h_remark'
                        style="position: relative;left:1.5rem;width:6.5rem;height:1.5rem;top:0.2rem"/>
              <span v-else style="position: relative;left:1rem;top:0.23rem;">{{Storemsg1.h_remark}}</span>
            </div>
            <!--报价情况-->
            <li class="child">
              <div class="radiobox">
                <span><i class="require_icon">*</i>报价情况:</span>
                <span style="margin-left:1rem;margin-right:2.25rem;">
                  <input type="radio" v-if="state=='5'||state=='4'||state=='1' " name="have_b" :value="1"  @click="havebbtn(1)" :checked="Storemsg1.have_b==1" v-model="Storemsg1.have_b">
                  <input type="radio" v-else name="have_b" :value="1"  @click="havebbtn(1)" :checked="Storemsg1.have_b==1" v-model="Storemsg1.have_b" disabled>
                 <label>有</label>
              </span>
                <span>
                  <input v-if="state=='5'||state=='4'||state=='1' " type="radio" name="have_b" value="2" @click="havebbtn(2)" :checked="Storemsg1.have_b==2" v-model="Storemsg1.have_b">
                  <input  v-else type="radio" name="have_b" :value="2" @click="havebbtn(2)" :checked="Storemsg1.have_b==2" v-model="Storemsg1.have_b" disabled>
                  <label>无</label>
               </span>
              </div>
            </li>
            <div style="border-bottom:1px solid #ccc;width:100%;height:1.8rem;" v-if="Storemsg1.have_b==2" >
              <span v-if="state=='5'||state=='4'||state=='1' " style="position:relative;top:-1rem;left:0.25rem;"><i class="require_icon">*</i>报价备注</span>
              <span  v-else style="position:relative;top:0.3rem;left:0.25rem;"><i class="require_icon">*</i>报价备注</span>
              <textarea v-if="state=='5'||state=='4'||state=='1' "   placeholder="请上传BOSS系统至少有我司盖章版报价" v-model='Storemsg1.b_remark'
                        style="position: relative;left:1.5rem;width:6.5rem;height:1.5rem;top:0.2rem"/>
              <span v-else style="position: relative;left:1rem;top:0.23rem;">{{Storemsg1.b_remark}}</span>
            </div>
            <!--开工函情况-->
            <li class="child">
              <div class="radiobox">
                <span><i class="require_icon">*</i>开工函情况:</span>
                <span style="margin-left:0.7rem;margin-right:2.25rem;">
                  <input type="radio" v-if="state=='5'||state=='4'||state=='1' " name="have_k" :value="1"  @click="havekbtn(1)" :checked="Storemsg1.have_k==1" v-model="Storemsg1.have_k">

                  <input type="radio" v-else name="have_k" :value="1"  @click="havekbtn(1)" :checked="Storemsg1.have_k==1" v-model="Storemsg.have_k" disabled>
                 <label>有</label>
              </span>
                <span>
                   <input  v-if="state=='5'||state=='4'||state=='1' "  type="radio" name="have_k" value="2" @click="havekbtn(2)" :checked="Storemsg1.have_k==2" v-model="Storemsg1.have_k">
                  <input  v-else type="radio" name="have_k" value="2" @click="havekbtn(2)" :checked="Storemsg1.have_k==2" v-model="Storemsg.have_k" disabled>
                  <label>无</label>
               </span>
              </div>
            </li>
            <div style="border-bottom:1px solid #ccc;width:100%;height:1.8rem;" v-if="Storemsg1.have_k==2" >
              <span v-if="state=='5'||state=='4'||state=='1' " style="position:relative;top:-1rem;left:0.25rem;"><i class="require_icon">*</i>开工函备注</span>
              <span v-else style="position:relative;top:0.2rem;left:0.25rem;"><i class="require_icon">*</i>开工函备注</span>
              <textarea v-if="state=='5'||state=='4'||state=='1'" placeholder="请上传甲方签字和日期或者甲方确认盖章版验收函，如果现在提供不了请作说明，并告知下什么时候可以提供" v-model='Storemsg1.k_remark'
                        style="position: relative;left:1.2rem;width:6.5rem;height:1.5rem;top:0.2rem"/>
              <span v-else style="position: relative;top:0.2rem;left:0.6rem;" >{{Storemsg1.k_remark}}</span>
            </div>
            <!--验收函情况-->
            <li class="child">
              <div class="radiobox">
                <span><i class="require_icon">*</i>验收函情况:</span>
                <span style="margin-left:0.7rem;margin-right:2.25rem;">
                  <input type="radio" v-if="state=='5'||state=='4'||state=='1'" name="have_y" :value="1"  @click="haveybtn(1)" :checked="Storemsg1.have_y==1" v-model="Storemsg1.have_y">

                  <input type="radio" v-else name="need_mail" :value="1"  @click="haveybtn(1)" :checked="Storemsg1.have_y==1" v-model="Storemsg.have_y" disabled>
                 <label>有</label>
              </span>
                <span>
                   <input v-if="state=='5'||state=='4'||state=='1' " type="radio" name="have_y" value="2" @click="haveybtn(2)" :checked="Storemsg1.have_y==2" v-model="Storemsg1.have_y">
                  <input  v-else type="radio" name="have_y" value="2" @click="haveybtn(2)" :checked="Storemsg1.have_y==2" v-model="Storemsg1.have_y" disabled>
                  <label>无</label>
               </span>
              </div>
            </li>
            <div style="border-bottom:1px solid #ccc;width:100%;height:1.8rem;" v-if="Storemsg1.have_y==2" >
              <span v-if="state=='5'||state=='4'||state=='1' " style="position:relative;top:-1rem;left:0.25rem;"><i class="require_icon">*</i>验收函备注</span>
              <span v-else style="position:relative;top:0.1rem;left:0.25rem;"><i class="require_icon">*</i>验收函备注</span>
              <textarea v-if="state=='5'||state=='4'||state=='1' "   placeholder="请上传甲方签字和日期或者甲方确认盖章版验收函，如果现在提供不了请作说明，并告知下什么时候可以提供" v-model='Storemsg1.y_remark'
                        style="position: relative;left:1.2rem;width:6.5rem;height:1.5rem;top:0.2rem"/>
              <span v-else style="position: relative;left:0.5rem;top:0.1rem;" >{{Storemsg1.y_remark}}</span>

            </div>
          </ul>
          <div>
            <p style="padding-left: 0.3rem;">留言：</p>
            <ul class="per_say">
              <li v-for="(item,index) in log_data" :key="index">
                <span style="margin-right:0.4rem">{{item.name}}</span>
                <span style="margin-right:0.4rem">{{item.created_at?(item.created_at).slice(0,10):''}}</span>
                <span>{{item.remark}}</span>
              </li>
            </ul>
          </div>

        </div>
      </mt-tab-container-item>
      <!--开票留言-->

    </mt-tab-container>
    <!--<div class="store-wrap"  v-if="state!='5'" >-->
      <!--<div class="storemsg" style="margin-left: -0.1rem">{{this.Status[this.state]}}</div>-->
    <!--</div>-->
    <div class="store-wrap" v-if="state=='5'||state=='4'||state=='1' ">
      <div class="storemsg" style="margin-left: -0.1rem" @click="StoreConirm">保存</div>
    </div>
    <div class="store-wrap"  v-else >
     <div></div>
    </div>


  </div>
</template>
<script>
  import { Navbar, TabItem ,Popup , Picker,Field,MessageBox,DatetimePicker,Radio} from 'mint-ui'
  import nodata from '../public/nodata'
  import Vue from 'vue'
 import { formatDate } from '../../assets/js/slotsList1';


  Vue.component(Navbar.name, Navbar);
  Vue.component(TabItem.name, TabItem);
  Vue.component(Popup.name, Popup);
  Vue.component(Field.name, Field);
  Vue.component(DatetimePicker.name, DatetimePicker);
  Vue.component(Radio.name, Radio);


  export default {
    components:{
      nodata
    },
    filters: {
      formatDate(time) {
        var date = new Date(time);
        return formatDate(date, 'yyyy-MM-dd');
      }
    },
  data(){

    return {
      data:{},
      data1:{},
      data2:{},
      showinfo:1,
      showinfo1:1,
      value: new Date(),
      time1:'',
      openindex:null,
      // valuetime: new Date(),          //定义显示时间
      visible: false,
      startDate: new Date('2000-01-01'),      //设置开始时间
      endDate: new Date('2200-01-22'),   //设置结束时间
      isshow:true,//开票留言
      selected: '1',
      // group:{1:'碧桂园',2:'万科',3:'恒大',4:'万科',5:'恒大'},
      periods:{1:'1',2:'2',3:'3',4:'4',5:'5',6:'6',7:'7',8:'8',9:'9'},
      popupVisible:false,

      show1state:1,
      project_list:[],//项目列表
      account_list:{},//账号选择
      tax_list:{},
      money_data:[],//开票金额数据
      Step:'',
      state:'',
      Status:{},
      OpenTicketId:'',//开票id
      needmail:1,//是否需要邮寄 1，是 2，否
      normaltype:1,//审核类型：正常/特殊
      ticket:{
        money:null,
        tax_type:'',
        scheduled_at:'',
      },
      temp:{
        id:'',
        order_id:'',
        higher_uid:''
      },
      id:'',
      leader:{},
      log_data:[],
      id:'',
      project_name:'',
      order_id:'',
      bill_string:'',//开票信息
     Storemsg:{//保存开票信息
       id:0,//开票id，如果是新建要传0
       // order_id:'',//	订单order_id
       project_name:'',//开票名称，可以为空不填
       // company_name:'',//甲方名称去除
       taxpayer_num:'',//纳税人识别号
       inv_bank_name:'',//开票银行名称
       inv_bank_account:'',//开票银行账户
       inv_phone:'',//	开票电话
       inv_address:'',//开票地址
       account:'',//我司账号
       company_char:1,//企业性质,1:小规模,2:一般纳税人
       inv_type:1,//开票类型,1:增值税专用,2:普通
       need_mail:2,//是否需要邮寄,1:需要,2:不需要
       mail_address:'',//邮寄地址
       higher_uid:0,//上级uid，一般情况下默认是0，特殊是leader.id
       mail_user:'',//邮寄收件人
       mail_phone:'',//邮寄收件人电话
       rev_remark:'',//发票备注
       type:1,//'审核类型,1:正常,2:特殊'
       // period:'',//开票周期
       money:[null],//开票金额
       tax_type:[''],//税率
       scheduled_at:[null],//预计回款时间
       have_type:[],//合同等附加
       have_remark:[],//备注


     },
      company_name:'',//甲方名称

Storemsg1:{
  have_h:1,//有无合同1 需要备注 2 不需要备注
  have_b:1,//有无报价
  have_k:1,//有无开工函
  have_y:1,//有无验收函

  h_remark:'',
  b_remark:'',
  k_remark:'',
  y_remark:'',


},

    }
  },
  methods:{

    FullBtnAction(){//智能填充按钮
      const html = `
        <div style="font-size:14px;border:1px solid #ccc;height:6rem" >
         <textarea placeholder="输入内容" style="font-size:14px;height:5.5rem;width:100%;" v-model="bill_string"></textarea>
        </div>
      `

      MessageBox.prompt('请输入开票信息').then(({ value, action }) => {

          // console.log(action)
          if (action =='confirm') {     //确认的回调
            this.$http.getInvoiceanalysis({bill_string:value}).then(res=>{
              this.Storemsg.inv_address=res.data.inv_address
              this.Storemsg.inv_bank_account=res.data.inv_bank_account
              this.Storemsg.inv_bank_name=res.data.inv_bank_name
              this.Storemsg.inv_phone=res.data.inv_phone
              this.company_name=res.data.company_name
              this.Storemsg.project_name=res.data.company_name
              this.Storemsg.taxpayer_num=res.data.taxpayer_num



            })
          }

      });

    },
    parseTime (time) {
      time = time == null ? '' : time
      if ( typeof time == 'object' ) {
        var d = new Date(time)
        let parseTime = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
        return parseTime
      } else {
        return time
      }
    },

    openclick(index) {
      // console.log(index)
      this.openindex=index
      this.$refs.picker[0].open()


    },
    handleConfirm(val){
      this.Storemsg.scheduled_at.push(val)
      this.Storemsg.scheduled_at[this.openindex]=(this.parseTime(val))
      this.showinfo1=this.Storemsg.money.length;
      this.Storemsg.scheduled_at= this.Storemsg.scheduled_at.slice(0,this.showinfo1)

    },
    handleCancel(){
      console.log('取消')
    },





    // showTimePicker () {  //显示时间选择弹窗
    //   console.log(11)
    //   this.timePopupVisible = true
    //
    // },
    // timeConfirm(){
    //   this.begin_time = this.c_begin_time
    //   this.end_time = this.c_end_time
    //   let data = {
    //     begin_time:this.begin_time,
    //     end_time:this.end_time
    //   }
    //   this.timePopupVisible = false
    //   console.log(this.c_begin_time)
    // },
    back () {
      // this.$router.go(-1)
      this.$router.push({ name:'openticketlist' })
    },

    companycharbtn(type){//企业性质
      this.Storemsg.company_char=type
    },
    invtypebtn(type){
      this.Storemsg.inv_type=type
    },
    needmailbtn(type){//是否需要邮寄
      this.Storemsg.need_mail=type
    },
    normaltypebtn(type){//类型，正常/特殊

      this.Storemsg.type=type
      if(type==1){
        this.Storemsg.higher_uid=0;
      }else{
        this.Storemsg.higher_uid=this.leader.id
      }

    },
    havehbtn(type){//是否有合同
      this.Storemsg1.have_h=type
      if(type==2){
        this.Storemsg1.h_remark=this.Storemsg1.h_remark
        this.have_remark.push(this.Storemsg1.h_remark)

      }
      else{
        this.Storemsg1.h_remark=' '
      }
      // this.Storemsg.have_type.push(type)
    },
    havekbtn(type){//是否有开工函
      this.Storemsg1.have_k=type
      if(type==2){
        this.Storemsg1.k_remark=this.Storemsg1.k_remark
        this.have_remark.push(this.Storemsg1.k_remark)

      }
      else{
        this.Storemsg1.k_remark=' '
      }
      // this.Storemsg.have_k.push(type)
    },
    haveybtn(type){//是否有验收函
      this.Storemsg1.have_y=type
      // this.Storemsg.have_y.push(type)
      if(type==2){
        this.Storemsg1.y_remark=this.Storemsg1.y_remark
        this.have_remark.push(this.Storemsg1.y_remark)
      }
      else{
        this.Storemsg1.y_remark=' '
      }
    },
    havebbtn(type){//是否有报价
      this.Storemsg1.have_b=type
      console.log(type)
      if(type==2){
        this.Storemsg1.b_remark=this.Storemsg1.b_remark
        this.have_remark.push(this.Storemsg1.b_remark)
      }
      else{
        this.Storemsg1.b_remark=' '
      }
      // this.Storemsg.have_y.push(type)
    },

    getProjectList(){//选择项目列表
      this.$router.push({name:'prolist',params:{proList:this.project_list}})

    },
    openticketmoney(){
      this.popupVisible=true;
    },
    cancelbtn(){
      // console.log('111')
      this.popupVisible=false;
    },
    surebtn(){
      this.popupVisible=false;
    },
    StoreConirm(){//保存按钮
      if(this.Step.step==1){
        this.Storemsg.id=0

      }
         if(this.Storemsg.taxpayer_num==''){
          MessageBox('提示', '纳税识别号不能为空')
        }

        if(this.Storemsg.inv_bank_name==''){
          MessageBox('提示', '开票银行名称不能为空')
        }
       if(this.Storemsg.inv_bank_account==''){
          MessageBox('提示', '开票银行账户不能为空')
        }

       if(this.Storemsg.money==''){
          MessageBox('提示', '开票金额不能为空')
        }
       if(this.Storemsg.tax_type==''){
        MessageBox('提示', '开票税率不能为空')
        }
       if(this.Storemsg.scheduled_at==''){
        MessageBox('提示', '预计回款时间不能为空')
       }


      else{

         this.Storemsg.have_type.push(this.Storemsg1.have_h)
         this.Storemsg.have_type.push(this.Storemsg1.have_b)
         this.Storemsg.have_type.push(this.Storemsg1.have_k)
         this.Storemsg.have_type.push(this.Storemsg1.have_y)

         this.Storemsg1.h_remark? this.Storemsg.have_remark.push(this.Storemsg1.h_remark):this.Storemsg.have_remark[0]=''
         this.Storemsg1.b_remark?this.Storemsg.have_remark.push(this.Storemsg1.b_remark):this.Storemsg.have_remark[1]=''
         this.Storemsg1.k_remark?this.Storemsg.have_remark.push(this.Storemsg1.k_remark):this.Storemsg.have_remark[2]=''
         this.Storemsg1.y_remark?this.Storemsg.have_remark.push(this.Storemsg1.y_remark):this.Storemsg.have_remark[3]=''

         // this.Storemsg.have_remark.push(this.Storemsg1.y_remark)
         // this.Storemsg.have_remark.push(this.Storemsg1.b_remark)



         this.$http.getInvoicingStore(this.Storemsg).then(res=>{

          if(res.errCode == 0){
            MessageBox('提示', '保存成功')
            var that=this
            setTimeout(function () {//保存成功跳转到开票申请页面
              that.$router.push({name:'openticketlist'})
            },2000)

          }else{
            MessageBox('提示', res.errMsg)
          }
        })

      }

    },
    addmoneybtn(){//添加金额按钮
      // console.log('添加金额')
      this.showinfo++;
      // console.log(this.showinfo)
      this.Storemsg.money.push(null);
      this.Storemsg.tax_type.push('');
      // this.Storemsg.scheduled_at.push('');
      // console.log(this.Storemsg.scheduled_at)
      // console.log(this.Storemsg.money)
    },
    delmoneybtn(index){
      this.showinfo--;
      this.Storemsg.money.splice(index,1)
      this.Storemsg.tax_type.splice(index,1);
      this.Storemsg.scheduled_at.splice(index,1);

    },

  },
  created(){
//开票列表数据
//     this.Step=step1.step
    this.Step=JSON.parse(window.localStorage.getItem('step') )

    this.$http.getOpenTicketListdata().then(res=>{
      // this.ProList=res.data.data
      // this.project_list=res.data.project_list
      // window.localStorage.setItem( 'prolist', JSON.stringify(this.project_list) )
      this.tax_list=res.data.tax_list
      // this.Status=res.data.status//状态
    })





    this.state=this.$route.params.state//审核状态

    if (this.$route.params.index){

      this.state=5


        this.Storemsg.order_id = this.$route.params.index
        if(this.Step.step==1){
          // console.log("this.step:",this.Step.step)
          this.id=0
        }
        else{
          this.id=JSON.parse ( window.localStorage.getItem('opeticket') ).id
        }




      this.$http.getInvoicingEdit({order_id:this.$route.params.index}).then(res=>{//编辑&&新建接口
        this.project_list=res.data.project_list
        this.account_list=res.data.account_list//我司账号选择
        this.money_data=res.data.money_data//金额
        this.leader=res.data.leader
        this.log_data=res.data.log_data
        // console.log(res.data.log_data)
        // this.Storemsg.order_id = this.$route.params.index//
        this.project_name = this.$route.params.name//项目名称，如果路由有值就用路由的值
        this.Storemsg.id=res.data.base_data.id;
        this.Storemsg.account=res.data.base_data.account;//新增我司账号
        this.Storemsg.project_name=res.data.base_data.project_name;
        this.company_name=res.data.base_data.company_name;//去除甲方名称
        this.Storemsg.taxpayer_num=res.data.base_data.taxpayer_num;
        this.Storemsg.inv_bank_name=res.data.base_data.inv_bank_name;
        this.Storemsg.inv_bank_account=res.data.base_data.inv_bank_account;
        this.Storemsg.inv_phone=res.data.base_data.inv_phone;
        this.Storemsg.inv_address=res.data.base_data.inv_address;
        this.Storemsg.company_char=res.data.base_data.company_char;
        this.Storemsg.inv_type=res.data.base_data.inv_type;
        this.Storemsg.all_money=res.data.base_data.all_money;
        // this.Storemsg.period=res.data.base_data.period;
        this.Storemsg.need_mail=res.data.base_data.need_mail;
        this.Storemsg.mail_address=res.data.base_data.mail_address;
        this.Storemsg.mail_user=res.data.base_data.mail_user;
        this.Storemsg.mail_phone=res.data.base_data.mail_phone;
        this.Storemsg.rev_remark=res.data.base_data.rev_remark;
        this.Storemsg.type=res.data.base_data.type;

        if(res.data.base_data.have_type!=null){
          this.Storemsg1.have_h=res.data.base_data.have_type[0]
          this.Storemsg1.have_b=res.data.base_data.have_type[1]
          this.Storemsg1.have_k=res.data.base_data.have_type[2]
          this.Storemsg1.have_y=res.data.base_data.have_type[3]
        }
        if(res.data.base_data.have_remark!=null){
          this.Storemsg1.h_remark=res.data.base_data.have_remark[0]
          this.Storemsg1.b_remark=res.data.base_data.have_remark[1]
          this.Storemsg1.k_remark=res.data.base_data.have_remark[2]
          this.Storemsg1.y_remark=res.data.base_data.have_remark[3]

        }

        if(res.data.money_data.length>0){
          this.Storemsg.money=res.data.money_data.map(item=>{
            return item.money
          })
          this.Storemsg.tax_type=res.data.money_data.map(item=>{
            return item.tax_type
          })
          this.Storemsg.scheduled_at=res.data.money_data.map(item=>{
            return item.scheduled_at
          })
        } else{
          this.Storemsg.money=[null]
          this.Storemsg.tax_type=['']
          // this.Storemsg.scheduled_at=['']
        }
      })

    }
else{
      // this.tax_list=this.$route.params.tax_list
  // console.log(this.$route.params.id)
      this.$http.getInvoicingEdit({id:this.$route.params.id}).then(res=>{//编辑&&新建接口
        this.project_list=res.data.project_list
        this.account_list=res.data.account_list//我司账号选择
        this.money_data=res.data.money_data//金额
        this.leader=res.data.leader
        this.log_data=res.data.log_data
        this.Storemsg.id=res.data.base_data.id;
        this.Storemsg.account=res.data.base_data.account;//新增我司账号

        this.Storemsg.order_id=res.data.base_data.order_id;
        this.project_name=res.data.project_list[res.data.base_data.order_id]
        this.Storemsg.project_name=res.data.base_data.project_name;
        this.company_name=res.data.base_data.company_name;//去除甲方名称
        this.Storemsg.taxpayer_num=res.data.base_data.taxpayer_num;
        this.Storemsg.inv_bank_name=res.data.base_data.inv_bank_name;
        this.Storemsg.inv_bank_account=res.data.base_data.inv_bank_account;
        this.Storemsg.inv_phone=res.data.base_data.inv_phone;
        this.Storemsg.inv_address=res.data.base_data.inv_address;
        this.Storemsg.company_char=res.data.base_data.company_char;
        this.Storemsg.inv_type=res.data.base_data.inv_type;
        this.Storemsg.all_money=res.data.base_data.all_money;
        // this.Storemsg.period=res.data.base_data.period;
        this.Storemsg.need_mail=res.data.base_data.need_mail;
        this.Storemsg.mail_address=res.data.base_data.mail_address;
        this.Storemsg.mail_user=res.data.base_data.mail_user;
        this.Storemsg.mail_phone=res.data.base_data.mail_phone;
        this.Storemsg.rev_remark=res.data.base_data.rev_remark;
        this.Storemsg.type=res.data.base_data.type;
        if(res.data.base_data.have_type!=null){
          this.Storemsg1.have_h=res.data.base_data.have_type[0]
          this.Storemsg1.have_b=res.data.base_data.have_type[1]
          this.Storemsg1.have_k=res.data.base_data.have_type[2]
          this.Storemsg1.have_y=res.data.base_data.have_type[3]

        }

        if(res.data.base_data.have_remark!=null){
          this.Storemsg1.h_remark=res.data.base_data.have_remark[0]
          this.Storemsg1.b_remark=res.data.base_data.have_remark[1]
          this.Storemsg1.k_remark=res.data.base_data.have_remark[2]
          this.Storemsg1.y_remark=res.data.base_data.have_remark[3]

        }
        if(res.data.money_data && res.data.money_data.length>0){
          this.Storemsg.money=res.data.money_data.map(item=>{
            return item.money
          })
          this.Storemsg.tax_type=res.data.money_data.map(item=>{
            return item.tax_type
            // return 1
          })
          this.Storemsg.scheduled_at=res.data.money_data.map(item=>{
            return item.scheduled_at.slice(0,10)
          })
        } else{
          this.Storemsg.money=[null]
          this.Storemsg.tax_type=['']
          this.Storemsg.scheduled_at=['']
        }

      })

    }


  },
    watch:{
      showinfo (val){
        // console.log(val)
       if(val){
          this.Storemsg.scheduled_at.push(this.time1)
       }
  },
    },

    mounted(){
      this.order_id=this.$route.params.index
      // this.tax_list=this.$route.params.tax_list
      this.data= JSON.parse ( window.localStorage.getItem('opeticket') )//opeticket开票列表直接进入

      let data2=  JSON.parse ( window.localStorage.getItem('opeticket2') )//opeticket2开票申请按钮
      let data3=  JSON.parse ( window.localStorage.getItem('choosepro') )//opeticket2开票申请按钮
      // this.tax_list=data2.tax_list||data.tax_list
      this.Storemsg.order_id=data3?data3.index : null
      this.Step=JSON.parse(window.localStorage.getItem('step') )


    }
}
</script>
<style scoped>
  .mint-msgbox-wrapper /deep/ .mint-msgbox-wrapper{
 height:100rem;
  }
  .picker_show /deep/ .mint-datetime-action{
    /* 时间选择的样式 */
    z-index: 10000;
    position: relative;
  }
  .picker_show /deep/ .picker-toolbar{
    z-index: 8000;
    position: fixed;
    width:100%;
    margin-bottom:40px;
    background:#fff;
  }
  .picker_show /deep/ .picker-items{
    margin-top:30px;
  }
  .fillbtn{
    margin-left: 1.2rem;
    color:#5483D2;
    width:3.8rem;
    height: 0.8rem;
    border-radius: 0.2rem;
  }
  .container {
    width: 100%;
    background-color: #FFF;
    /*overflow: auto;*/
  }
  .header{
    width: 100%;
    text-align: center;
    font-size: 0.375rem;
    background-color: #FFF;
    height: 1.04375rem;
    line-height: 1.09375rem;
    position: relative;
    z-index: 99;
    border-bottom:1px solid #ccc;
  }
.container /deep/ .mint-navbar{
  border-bottom:1px solid #ccc;
  color:#737171;

}
  .container /deep/ .mint-tab-item-label{
    font-size: 15px;
  }
  .container /deep/ .mint-navbar .mint-tab-item.is-selected{

  }
  .container /deep/ .mint-navbar .mint-tab-item.is-selected{
    color: #5483D2;
    font-weight: 600;
    text-decoration: none;
    position: relative;
    bottom:0;
    border-bottom:3px solid  #5483D2;
  }
 .openticketmsg{
   padding-bottom:10px;
 }
.openticketmsg>li{
  /*开票信息*/
  /*display: flex;*/
  justify-content:space-between;
  padding-left: 0.3rem;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #ccc;

}
  .openticketmsg>li>.child01{
 margin-left:1.2rem;
}
  .openticketmsg>li>.child02{
    margin-left:0.65rem;
  }
  input{
    width:6rem;
  }


.require_icon{
  font-style: normal;
  color:#FB2E45;
  display: inline-block;
  margin-right: 3px;
}

  .c_img01{
    width:15px;
    height: 15px;
    display: inline-block ;
    background: url('../../assets/img/circle1.png') no-repeat;
    background-size: 100% 100%;
    position: relative;
    top:4px;
    margin-right: 2px;
  }
  .c_img02{
    width:15px;
    height: 15px;
    display: inline-block ;
    background: url('../../assets/img/circle2.png') no-repeat;
    background-size: 100% 100%;
    position: relative;
    top:4px;
    margin-right: 2px;
  }
  .store-wrap{
    width:100%;
    padding:1.3rem;
  }
.storemsg{
  border:1.2px solid #5483D2 ;
  width:8rem;
  text-align:center ;
  height: 1rem;
  line-height: 1rem;
  border-radius: .5rem;
  font-size: 14px;
  color: #5483D2;
  margin-left: 0.2rem;
}
/*开票金额*/
.openticketmoney-wrap{
  margin-top:0.1rem;
  min-height:560px;
  overflow: auto;
  padding:0.2rem 0rem;
  /*background: #FAFAFA;*/

  background: #fff;

}
.openticketmoney{
 padding:0.3rem 0.2rem;
  background: #ffffff;
}
.addmoney{
  float: right;
  margin:0rem 0.3rem 0.4rem 0;
  width:2.2rem;
  border:1px dashed #ccc;
  padding:0.1rem;
  height:0.7rem ;
  /*line-height: 1.8rem;*/
  color:#979797
}
.ticketbox-wrap{
  margin-top:0.3rem;
}
  .ticketbox-content{
    position: relative;
    padding:0rem 0.1rem 0.2rem;
    margin-bottom:0.2rem;
    width:8.6rem;
    border:1px solid #F0F0F0;
    border-radius: 4px;

  }
  .ticketbox-content /deep/ .mint-cell-wrapper{
    font-size: 12px;
    padding-left: 10px;
    text-decoration: none;
  }
  .ticketbox-content /deep/ .mint-field-core{
    margin-left: 32px;
  }
  .ticketbox-content>li{
    height:1.2rem;
    line-height:1.2rem;
    border-bottom:1px solid #F0F0F0;
    display: flex;
    justify-content:space-between;

  }
  .ticketbox-content>li>span{
    display:inline-block;

  }
  .icon_del{
    width:20px;
    height: 20px;
    background: url('../../assets/img/减号.png') no-repeat;
    background-size: cover;
    position:absolute;
    right:-0.9rem;
    top:1.5rem;
  }
  .store-wrap2{
    margin-top:4.5rem;
    margin-left: 1.5rem;
  }
  .issurebtn{display: flex;}
  .issurebtn>span{flex:1;
    height: 1.4rem;
   line-height: 1.4rem;
  text-align: center;
  font-size:14px;}
  .cancelbtn{background:#F4F4F4;color:#696666 }
  .issurebtn{background: #E6EBF6;color: #696666}
  .choosetax{
    margin-top:1rem;
  }
  .taxs>li{
    padding-left:0.7rem;
    height: 1.2rem

  }
  .list-item{margin:0}
  input[type=radio] {
    display: inline-block;
    vertical-align: middle;
    width: 16px;
    height: 16px;
    -webkit-appearance: none;
    background-color: transparent;
    border: 0;
    outline: 0 !important;
    line-height: 16px;
    color: #d8d8d8;
  }
  input[type=radio]:after {
    content: "";
    display:block;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    text-align: center;
    line-height: 12px;
    font-size: 12px;
    color: #fff;
    border: 3px solid #ddd;
    background-color: #fff;
    box-sizing:border-box;
  }
  input[type=radio]:checked:after {
    content: "L";
    transform:matrix(-0.766044,-0.642788,-0.642788,0.766044,0,0);
    -webkit-transform:matrix(-0.766044,-0.642788,-0.642788,0.766044,0,0);
    border-color: #099414;
    background-color: #099414;
  }
  .leader{
    background: #fff;
    padding-bottom:0.6rem;
  }
  .leader_title{
    background: #E1E2E4;
   padding-left: 0.3rem;
    margin-bottom: 0.4rem;
    height: 1rem;
    line-height: 1rem;
  }
  .img02{
    width:48px;
    height: 48px;
    position: relative;
    top:10px;

  }
  .avatar-name{
    position: relative;
    top:-7px;
    left:-38px;
    font-size:20px;
  }
  .userimg{
    padding-left: 10px;
  }
  .all_leader{
    display: flex;
  }
  .dasheline{
    position: absolute;
    top:1rem;
    right:0.3rem;
    display: inline-block;
    width: 1.4rem;
    border-bottom:1px dashed #ccc;

  }
  .all_leader>li{
   flex:1;
    position: relative;

  }
  .per_say{
    padding:0.3rem;
  }
.per_say>li{
  min-height: 1rem;
}
</style>

<style>
  .mint-msgbox-input input {
    height:2rem !important;
    word-break : normal break-all  keep-all !important;

  }
</style>



// WEBPACK FOOTER //
// src/components/drillPage/OpenTicket.vue